export default "__VITE_ASSET__DGet1fD8__"